import React, { useEffect, useState } from "react";
import { updateUserInDatabase, uploadMedia } from "../fireabse";
import { updateResume } from "../redux/slices/user";
import { useDispatch, useSelector } from "react-redux";
import img1 from "../images/27.png";

const UploadPDF = () => {
  return (
    <>
      <h1>Hello</h1>
    </>
  );
};

export default UploadPDF;
